import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Shield, Brain, ListChecks, Activity, HeartHandshake } from 'lucide-react';
export function TransformationSection() {
  const transformations = [{
    icon: Shield,
    title: 'Más seguridad',
    text: 'Llegás a cada práctica sabiendo qué valorar, qué buscar y qué registrar.'
  }, {
    icon: Brain,
    title: 'Más criterio clínico',
    text: 'Pasás de memorizar pasos sueltos a pensar como enfermería clínica real.'
  }, {
    icon: ListChecks,
    title: 'Menos improvisación',
    text: 'Tenés protocolos, esquemas, tablas, bonos y casos que ordenan tu trabajo.'
  }, {
    icon: Activity,
    title: 'Más claridad',
    text: 'Signos vitales, red flags, medicación, registros y procedimientos: todo conectado.'
  }, {
    icon: HeartHandshake,
    title: 'Más confianza en prácticas',
    text: 'Tu tutor lo nota. Tus compañeros lo notan. Vos lo sentís.'
  }];
  return <section className="py-12 md:py-20 lg:py-24 bg-white" data-id="element-463">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-464">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14" data-id="element-465">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-4" data-id="element-466">
            La transformación
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black text-clinical-deep mb-4 leading-[1.05] uppercase" data-id="element-467">
            Lo que cambia con un <br className="hidden md:block" data-id="element-468" />
            <span className="accent-italic normal-case" data-id="element-469">
              sistema clínico claro
            </span>
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-base md:text-lg text-clinical-ink leading-relaxed space-y-2 mt-4" data-id="element-470">
            <p data-id="element-471">
              No se trata de estudiar más horas. Se trata de estudiar con{' '}
              <span className="accent-italic" data-id="element-472">estructura</span>.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-473">
          {transformations.map((item, idx) => {
          const isLast = idx === transformations.length - 1;
          const Icon = item.icon;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className={`bg-clinical-base rounded-2xl p-5 md:p-6 border border-clinical-line text-center md:text-left ${isLast ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-474">
                <div className="w-11 h-11 rounded-xl bg-white border border-clinical-line flex items-center justify-center mb-4 mx-auto md:mx-0" data-id="element-475">
                  <Icon className="w-5 h-5 text-clinical-mid" strokeWidth={2} data-id="element-476" />
                </div>
                <h4 className="text-lg font-bold text-clinical-deep mb-2 uppercase" data-id="element-477">
                  {item.title}
                </h4>
                <p className="text-sm md:text-base text-clinical-ink leading-relaxed" data-id="element-478">
                  {item.text}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}